/*
 * card-size-atc.js — Gracies
 * Agrega al carrito la talla clickeada desde la product card y abre el cart-drawer.
 * Reutiliza exactamente la misma fontanería que product-form.js del tema Zest:
 *   - POST a FoxThemeSettings.routes.cart_add_url con las secciones a re-renderizar
 *   - emite PUB_SUB_EVENTS.cartUpdate -> cart-drawer.js renderiza y abre el drawer
 */
if (!customElements.get("card-size-atc")) {
  customElements.define(
    "card-size-atc",
    class CardSizeAtc extends HTMLElement {
      connectedCallback() {
        this.onClickHandler = this.onClick.bind(this);
        this.addEventListener("click", this.onClickHandler);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClickHandler);
      }

      async onClick(evt) {
        const btn = evt.target.closest("button[data-variant-id]");
        if (
          !btn ||
          btn.disabled ||
          btn.getAttribute("aria-disabled") === "true" ||
          btn.classList.contains("is-loading")
        ) {
          return;
        }

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const Settings = window.FoxThemeSettings || {};
        const routes = Settings.routes || {};
        const addUrl = routes.cart_add_url || "/cart/add.js";

        btn.classList.add("is-loading");

        // Secciones a re-renderizar (drawer + carrito de página si existen)
        const cartDrawer = document.querySelector("cart-drawer");
        const mainCart = document.querySelector("cart-items");
        let sections = [];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
          sections = sections.concat(
            cartDrawer.getSectionsToRender().map((s) => s.id)
          );
        }
        if (mainCart && typeof mainCart.getSectionsToRender === "function") {
          sections = sections.concat(
            mainCart.getSectionsToRender().map((s) => s.section)
          );
        }

        const body = new FormData();
        body.append("id", variantId);
        body.append("quantity", 1);
        if (sections.length) {
          body.append("sections", sections.join(","));
          body.append("sections_url", window.location.pathname);
        }

        try {
          const response = await fetch(addUrl, {
            method: "POST",
            headers: {
              Accept: "application/javascript",
              "X-Requested-With": "XMLHttpRequest",
            },
            body,
          });
          const data = await response.json();

          // Error (ej: sin stock por carrera de inventario)
          if (data.status) {
            this.notify(
              "warning",
              data.description || data.message,
              true
            );
            return;
          }

          const openDrawer =
            cartDrawer && Settings.cart && Settings.cart.openDrawerWhenAdded;

          // Confirmación visual en el botón (✓) por un instante.
          btn.classList.remove("is-loading");
          btn.classList.add("is-added");
          setTimeout(() => btn.classList.remove("is-added"), 1200);

          // Drawer existe -> el cartUpdate lo renderiza y abre solo.
          if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== "undefined") {
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);
          }

          // Sin drawer (carrito tipo página): actualizar contador + aviso.
          if (!openDrawer) {
            if (window.FoxThemeCartHelpers) {
              window.FoxThemeCartHelpers.getState().then((state) => {
                window.FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }
            this.notify(
              "success",
              (window.FoxThemeStrings && window.FoxThemeStrings.item_added) ||
                "",
              false
            );
          }

          // Evento para terceros (apps/pixels), igual que product-form.js
          document.dispatchEvent(
            new CustomEvent("product-ajax:added", {
              detail: { product: data },
            })
          );
        } catch (e) {
          console.error("card-size-atc:", e);
        } finally {
          btn.classList.remove("is-loading");
        }
      }

      notify(type, message, sticky) {
        if (!message) return;
        const N = window.FoxTheme && window.FoxTheme.Notification;
        if (!N || typeof N.show !== "function") return;
        N.show({
          target: document.body,
          method: "appendChild",
          type,
          message,
          last: 3000,
          sticky: !!sticky,
        });
      }
    }
  );
}